import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import SingleFaq from './SingleFaq';

import '../../pages/page-styles.scss';

/** Bold underlined text at the start of a paragraph is the question; one with no answer is a heading. */
const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const [first] = node.content;
      const marks = (first?.marks || []).map(m => m.type);
      if (!marks.includes(MARKS.BOLD) || !marks.includes(MARKS.UNDERLINE)) {
        return <p>{children}</p>;
      }
      if (node.content.length === 1) {
        return <h3 className="is-size-3 mb-2">{first.value}</h3>;
      }
      return (
        <SingleFaq header={first.value} content={<p>{children.slice(1)}</p>} />
      );
    },
  },
};

const FaqComponent = () => {
  const { contentfulAbout } = useStaticQuery(graphql`
    {
      contentfulAbout(title: { eq: "iDECIDE FAQs" }) {
        content {
          raw
        }
      }
    }
  `);
  const content = JSON.parse(contentfulAbout.content.raw);

  return (
    <section className="section has-background-info anchor" id="FAQ">
      <div className="content">
        <div className="container mt-6">
          <div>
            <div className="is-flex is-flex-wrap-wrap is-justify-content-center mb-5" style={{ gap: '1rem' }}>
              {[
                ['es', 'Español'],
                ['pt', 'Português'],
                ['ht', 'Kreyòl ayisyen'],
                ['vi', 'Tiếng Việt'],
              ].map(([code, lang]) => (
                <a
                  key={code}
                  href={`/iDECIDE_FAQ_${code}.pdf`}
                  download={`iDECIDE_FAQ_${code}.pdf`}
                  className="button is-light has-text-weight-semibold has-text-white has-background-primary"
                >
                  iDECIDE FAQs, {lang}
                </a>
              ))}
            </div>
            {documentToReactComponents(content, options)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqComponent;
